import { compose } from "redux";
import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../models/Action";
import { immutableSet } from "../../../utils/immutable";
import { actionTypes } from "./actions";
import { STATE_IDENTIFIER } from "./constants";
import emptyState from "./emptyState";
import { actionTypes as profileMgmtActions } from "../../../pages/ProfileManagement/module/actions";

const {
  CALL_STATE,
  PWD_POLICY,
  TEMP_TOKEN,
  TEMP_TOKEN_TYPE,
  UIGP_OTP_RECEIVER,
  AUTH_RESPONSE_ERROR,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_TEMP_TOKEN_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.GET_TEMP_TOKEN_REQUEST_SUCCESS]: (state: any, action: any) =>
    compose(
      immutableSet([CALL_STATE], IResponseState.SUCCESS),
      immutableSet([TEMP_TOKEN_TYPE], action.payload.token_type),
      immutableSet([TEMP_TOKEN], action.payload.access_token)
    )(state),
  [actionTypes.GET_TEMP_TOKEN_REQUEST_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([CALL_STATE], IResponseState.ERROR),
      immutableSet([TEMP_TOKEN_TYPE], ""),
      immutableSet([TEMP_TOKEN], "")
    )(state),

  // UIGP OTP
  [actionTypes.GENERATE_UIGP_OTP]: (state: any, action: any) =>
    compose(
      immutableSet([CALL_STATE], IResponseState.PENDING),
      immutableSet([AUTH_RESPONSE_ERROR], false)
    )(state),
  [actionTypes.GENERATE_UIGP_OTP_SUCCESS]: (state: any, action: any) => {
    const contactFound = action.payload.result;
    return compose(
      immutableSet([CALL_STATE], IResponseState.SUCCESS),
      immutableSet(
        [UIGP_OTP_RECEIVER],
        contactFound ? action.payload.response : ""
      )
    )(state);
  },
  [actionTypes.GENERATE_UIGP_OTP_FAILURE]: (state: any, action: any) =>
    compose(
      immutableSet([CALL_STATE], IResponseState.ERROR),
      immutableSet([UIGP_OTP_RECEIVER], ""),
      immutableSet(
        [AUTH_RESPONSE_ERROR],
        action.payload.response.status === 403
      )
    )(state),

  [actionTypes.VERIFY_CHANGE_MOBILE_EMAIL_OTP]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.VERIFY_CHANGE_MOBILE_EMAIL_OTP_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.VERIFY_CHANGE_MOBILE_EMAIL_OTP_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.VERIFY_CHANGE_MOBILE_SEC_QUESTIONS]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.VERIFY_CHANGE_MOBILE_SEC_QUESTIONS_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.VERIFY_CHANGE_MOBILE_SEC_QUESTIONS_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [actionTypes.VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  [profileMgmtActions.VALIDATE_MOBILE_NUMBER]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [profileMgmtActions.VALIDATE_MOBILE_NUMBER_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [profileMgmtActions.VALIDATE_MOBILE_NUMBER_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),

  // CHENAGE PASSWORD
  [actionTypes.GET_PASSWORD_POLICY_SUCCESS]: (state: any, action: any) =>
    immutableSet([PWD_POLICY], action.payload, state),
  [actionTypes.GET_PASSWORD_POLICY_FAILURE]: (state: any, action: any) =>
    immutableSet([PWD_POLICY], null, state),

  [actionTypes.CHANGE_PASSWORD_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.CHANGE_PASSWORD_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.CHANGE_PASSWORD_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.ERROR, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/login" ||
      action.payload.location.pathname === "/welcome")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
